<template>
  <div class="wrapper daftarkan-masjid">
    <div class="donation-detail">
      <div
        class="main-content bg-white"
        style="padding: 15px; padding-bottom: 30px;"
      >
        <div class="wrapper-form">
          <form
            @submit.prevent="handleRegister"
            method="post"
            enctype="multipart/form-data"
          >
            <!-- INFORMASI PENGURUS -->
            <h3>Informasi Penanggung Jawab</h3>
            <SizedBox :height="60" />

            <div class="form-group">
              <label for="fullname"><strong>Nama Lengkap</strong></label>
              <input
                v-model="fullname"
                type="text"
                class="form-control"
                placeholder="Nama Lengkap"
                name="fullname"
                readonly
              />
              <div
                class="error"
                v-if="$v.fullname.$dirty && !$v.fullname.required"
              >
                Nama Lengkap wajib diisi.
              </div>
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="email"><strong>Email</strong></label>
              <input
                v-model="email"
                type="text"
                class="form-control"
                placeholder="Email"
                name="email"
                readonly
              />
              <div class="error" v-if="$v.email.$dirty && !$v.email.required">
                Email wajib diisi.
              </div>
              <div class="error" v-if="$v.email.$dirty && !$v.email.email">
                Format email salah.
              </div>
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="no_telp"><strong>Nomor Telepon / HP</strong></label>
              <input
                v-model="no_telp"
                type="text"
                class="form-control"
                placeholder="Nomor Telepon / HP"
                name="no_telp"
                v-number-only
                readonly
              />
              <div
                class="error"
                v-if="$v.no_telp.$dirty && !$v.no_telp.required"
              >
                Nomor telepon wajib diisi.
              </div>
            </div>

            <!-- INFORMASI UMUM -->
            <SizedBox :height="50" />
            <h3>Informasi Kegiatan</h3>
            <SizedBox :height="60" />

            <div class="form-group">
              <label for="source"><strong>Sumber Pelaksana</strong></label>
              <input
                v-model="source"
                type="text"
                class="form-control"
                placeholder="Sumber Pelaksana"
                name="source"
                readonly
              />
              <div class="error" v-if="$v.source.$dirty && !$v.source.required">
                Sumber Pelaksana wajib diisi.
              </div>
            </div>

            <div class="form-group">
              <label for="title"><strong>Kegiatan</strong></label>
              <input
                v-model="title"
                type="text"
                class="form-control"
                placeholder="Kegiatan"
                name="title"
                readonly
              />
              <div class="error" v-if="$v.title.$dirty && !$v.title.required">
                Nama Kegiatan wajib diisi.
              </div>
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="implement_date"
                ><strong>Tanggal Pelaksanaan</strong></label
              >
              <!-- <input
                v-model="implement_date"
                type="text"
                class="form-control"
                placeholder="Tanggal Pelaksanaan"
                name="implement_date"
              /> -->
              <p style="padding: 10px 0px;">{{ implement_date }}</p>
              <div
                class="error"
                v-if="$v.implement_date.$dirty && !$v.implement_date.required"
              >
                Tanggal Pelaksanaan wajib diisi.
              </div>
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="address">
                <strong>Lokasi </strong>
                <!-- <button
                  type="button"
                  class="btn btn-titik-jemput"
                  @click="modalMap()"
                >
                  Set Titik
                </button> -->
              </label>
              <textarea
                v-model="address"
                type="text"
                class="form-control"
                style="height: 120px !important;"
                placeholder="Lokasi"
                name="address"
                readonly
              ></textarea>
              <span style="font-size: 11px">
                titik koordinat, latitude: <strong>{{ center.lat }}</strong
                >, longitude:
                <strong>{{ center.lng }}</strong>
              </span>

              <div
                class="error"
                v-if="$v.address.$dirty && !$v.address.required"
              >
                Alamat wajib diisi.
              </div>
            </div>

            <div class="form-group">
              <label for="title"><strong>Deskripsi Kegiatan</strong></label>
              <!-- <wysiwyg v-model="description" /> -->
              <tinymce
                id="d1"
                v-model="description"
                :other_options="options"
              ></tinymce>
            </div>

            <!-- INFORMASI UMUM -->
            <SizedBox :height="50" />
            <h3>Gallery Kegiatan</h3>
            <SizedBox :height="60" />

            <h5>
              Foto :
            </h5>

            <div>
              <div class="row">
                <div class="col-12">
                  <silent-box :gallery="images" />
                </div>
              </div>
            </div>

            <SizedBox :height="30" />

            <h5>Video:</h5>

            <div>
              <div class="row">
                <div class="col-12">
                  <template v-if="video">
                    <div class="player-container">
                      <vue-core-video-player
                        @play="play"
                        :src="video.src"
                      ></vue-core-video-player>
                    </div>
                  </template>
                </div>
              </div>
            </div>

            <SizedBox :height="60" />

            <!-- <div class="row mb-2">
              <div class="col-6">
                <a
                  href="javascript:void(0)"
                  class="btn btn-success btn-full"
                  @click="backtoLaporan()"
                >
                  <i class="fa fa-edit"></i> Ubah
                </a>
              </div>
              <div class="col-6">
                <a
                  href="javascript:void(0)"
                  class="btn btn-danger btn-full"
                  @click="backtoLaporan()"
                >
                  <i class="fa fa-trash"></i> Hapus
                </a>
              </div>
            </div> -->

            <div class="form-group">
              <a
                href="javascript:void(0)"
                class="btn btn-cta btn-full"
                @click="backtoLaporan()"
              >
                Kembali Ke Daftar Laporan
              </a>
            </div>
          </form>
        </div>
      </div>

      <!-- Modal Map -->
      <modal class="map-wrapper" name="map-wrapper" :clickToClose="false">
        <div class="map-body">
          <div class="map-search">
            <div class="search-wrapper">
              <GmapAutocomplete
                @place_changed="setPlace"
                class="form-control"
                :options="{ fields: ['geometry'] }"
              />
              <img src="/img/icon-search.png" class="icon-search" />
            </div>
          </div>
          <gmap-map
            :center="center"
            :zoom="zoom"
            style="width: 100%; height: 100% !important;"
            :options="mapOptions"
          >
            <gmap-marker
              :position="center"
              @click="center = center"
              :draggable="true"
              @drag="updateCoordinates"
              @dragend="gMapFunc($event.latLng)"
              :icon="{
                url:
                  'https://api.masjed.id/assets/icons/menus/marker_cari_masjed.png',
                scaledSize: { width: 70, height: 70 },
                labelOrigin: { x: 16, y: -10 },
              }"
            ></gmap-marker>
          </gmap-map>
          <div class="current-location" @click="geolocate">
            <font-awesome-icon icon="crosshairs" />
          </div>
        </div>
        <SizedBox :height="15" />
        <div class="map-footer">
          <a
            href="javascript:void(0)"
            class="btn btn-cta btn-full"
            @click="saveCoordinates"
            >Simpan</a
          >
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import TopBar from "../../components/FixedTopbar.vue";
import SizedBox from "../../components/SizedBox.vue";
import { required, email } from "vuelidate/lib/validators";
import axios from "../../utils/masjedapi";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import tinymce from "vue-tinymce-editor";
import moment from "moment";
import $ from "jquery";

export default {
  name: "donation-detail",
  components: {
    TopBar,
    SizedBox,
    DatePicker,
    tinymce,
  },
  data() {
    return {
      options: {
        height: 300,
        menubar: false,
        toolbar:
          "undo redo | styleselect | forecolor | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | link image | code",
      },

      isSubmit: false,

      counterFotoKurban: [],

      fullname: "",
      email: "",
      no_telp: "",

      title: "",
      source: "",
      address: "",
      implement_date: "",
      description: "",

      masjidmaps_id: "",

      fotoFiles: [],

      images: [],
      video: null,

      // maps
      center: { lat: 45.508, lng: -73.587 },
      zoom: 17,
      markers: [],
      currentPlace: null,
      mapOptions: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: true,
      },
      reff_code: "",

      video_url: null,
      video_file: null,

      id: "",
    };
  },
  validations: {
    source: {
      required,
    },
    fullname: {
      required,
    },
    email: {
      required,
      email,
    },
    no_telp: {
      required,
    },
    title: {
      required,
    },
    address: {
      required,
    },
    implement_date: {
      required,
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.geolocate();

    this.reff_code = this.$route.params.ref_code;

    this.fetchOne();
  },
  methods: {
    play() {},
    addFotoKurban() {
      let length = this.counterFotoKurban.length;

      const attributes = {
        id: length + 1,
        name: "fotokegiatan[]",
      };

      if (length < 5) {
        this.counterFotoKurban.push(attributes);
      }
    },
    async handleRegister() {
      this.$v.$touch();

      this.isSubmit = true;

      const formData = new FormData();

      if (this.fotoFiles.length > 0) {
        console.log(this.fotoFiles);

        var filtered = this.fotoFiles.filter(function(el) {
          return el != null;
        });

        filtered.forEach((item) => {
          formData.append("fotokegiatan[]", item.file);
        });
      }

      if (this.video_file) formData.append("video_file", this.video_file);

      formData.append("fullname", this.fullname);
      formData.append("email", this.email);
      formData.append("no_telp", this.no_telp);

      formData.append("source", this.source);
      formData.append("title", this.title);
      formData.append("address", this.address);
      formData.append(
        "implement_date",
        moment(this.implement_date).format("YYYY-MM-DD h:mm:ss")
      );

      formData.append("lat", this.center.lat);
      formData.append("lng", this.center.lng);

      formData.append("description", this.description);
      formData.append("code", this.reff_code);

      if (this.$v.$invalid) {
        this.isSubmit = false;
      } else {
        const self = this;
        $.ajax({
          // url: `http://localhost:8000/laporkan`,
          url: `https://api.masjed.id/laporkan`,
          type: "POST",
          data: formData,
          processData: false, // tell jQuery not to process the data
          contentType: false, // tell jQuery not to set contentType
          success: function(data) {
            console.log(data);
            alert(data);
            self.$router.push({
              name: "laporkan-success",
              params: { ref_code: self.reff_code },
            });
          },
          error: function(error) {
            console.log(error);
          },
        });
      }
      this.isSubmit = false;
    },
    modalMap() {
      this.$modal.show("map-wrapper");
    },
    gMapFunc(evnt) {
      const self = this;
      const lat = parseFloat(evnt.lat().toFixed(7));
      const lng = parseFloat(evnt.lng().toFixed(7));

      this.masjidmaps_id = "";
      this.masjid_name = "";
    },
    setPlace(place) {
      const lat = parseFloat(place.geometry.location.lat().toFixed(7));
      const lng = parseFloat(place.geometry.location.lng().toFixed(7));

      this.center = {
        lat: lat,
        lng: lng,
      };
    },
    geolocate() {
      const self = this;

      navigator.geolocation.getCurrentPosition((position) => {
        const lat = parseFloat(position.coords.latitude);
        const lng = parseFloat(position.coords.longitude);

        this.center = {
          lat: lat,
          lng: lng,
        };

        this.masjidmaps_id = "";
        this.masjid_name = "";
      });
    },
    updateCoordinates(location) {
      const lat = parseFloat(location.latLng.lat().toFixed(7));
      const lng = parseFloat(location.latLng.lng().toFixed(7));

      this.center = {
        lat: lat,
        lng: lng,
      };

      this.$toasted.show("Titik berhasil diupdate.", {
        type: "success",
        position: "bottom-center",
        duration: 3000,
      });
    },
    updateCoordinates(location) {
      const lat = parseFloat(location.latLng.lat().toFixed(7));
      const lng = parseFloat(location.latLng.lng().toFixed(7));

      this.center = {
        lat: lat,
        lng: lng,
      };
    },
    handleClick(lat, lng, mapid = "", name = "") {
      this.center = {
        lat: parseFloat(lat),
        lng: parseFloat(lng),
      };

      this.masjidmaps_id = mapid;
      this.masjid_name = name;

      this.$toasted.show("Titik berhasil diupdate.", {
        type: "success",
        position: "bottom-center",
        duration: 3000,
      });
    },
    saveCoordinates() {
      this.$modal.hide("map-wrapper");
      this.$toasted.show("Titik berhasil diset.", {
        type: "success",
        position: "bottom-center",
        duration: 3000,
      });
      this.getAddresss(
        parseFloat(this.center.lat),
        parseFloat(this.center.lng)
      );
    },
    handleFileChange(e, index) {
      const objFile = e.target.files[0];
      const file = {
        id: index,
        url: URL.createObjectURL(objFile),
        file: objFile,
      };

      this.fotoFiles[index] = file;
    },

    onVideoFileChanged(e) {
      const file = e.target.files[0];
      this.video_url = URL.createObjectURL(file);
      this.video_file = file;
    },

    getAddresss(lat, lng) {
      var url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyDd-Xv_wBoM5_oaEwAuDpIy_nTRCkKX2EI&sensor=false`;
      var self = this;
      $.get(url, function(data) {
        var results = data.results;
        if (data.status === "OK") {
          if (results[0]) {
            var address_components = results[0];
            self.address = address_components.formatted_address;
          }
        }
      });
    },
    fetchOne() {
      const { id } = this.$route.params;
      const self = this;
      axios.get(`/laporkan/${id}`).then((response) => {
        const { data } = response.data;

        this.fullname = data.pic_fullname;
        this.email = data.pic_email;
        this.no_telp = data.pic_number;
        this.title = data.name;
        this.source = data.source;
        this.address = data.address;
        this.implement_date = moment(data.implement_date).format(
          "DD MMMM YYYY hh:mm:ss"
        );
        this.description = data.description;
        this.images = data.images;
        this.video = data.videos;
      });
    },
    backtoLaporan() {
      const { ref_code } = this.$route.params;

      this.$router.push({
        name: "laporkan",
        params: {
          ref_code,
        },
      });
    },
  },
  directives: {
    numberOnly: {
      bind: function(el) {
        el.handler = function() {
          el.value = el.value.replace(/\D+/, "");
        };
        el.addEventListener("input", el.handler);
      },
      unbind: function(el) {
        el.removeEventListener("input", el.handler);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  width: 100%;
  max-width: 480px;
  margin: 0px auto;
  box-sizing: border-box;
  top: 0px;
  padding: 0px;
  min-height: calc(100vh - 0px);
}

.wrapper-form {
  position: relative;
  h3 {
    position: absolute;
    font-size: 17px;
    margin: 0px;
    left: -15px;
    background: transparent linear-gradient(180deg, #28a745 0%, #145423 100%) 0%
      0% no-repeat padding-box;
    padding: 5px 40px 5px 10px;
    color: #fff;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
  }
}

.error {
  font-size: 11px;
  color: rgb(255, 13, 13);
}

.btn-add-foto {
  background: #efefef !important;
  border-radius: 10px !important;
  color: #999;
  font-weight: normal !important;
  padding: 5px 10px !important;
}

.keterangan {
  background: #fff3dc;
  font-size: 11px;
  padding: 5px 10px;
  margin-top: 10px;
  border-radius: 10px;
  p {
    font-weight: bold;
    margin: 0px;
    padding: 0px;
  }

  ul {
    list-style-type: none;
    margin: 0px;
    padding: 0px 20px;
  }
}

.form-control {
  background: white !important;
  border: none !important;
}
</style>
